bam-yt-video {
  .yt-wrapper {
    position: relative;
    aspect-ratio: 16/9;
  }

  lite-youtube {
    border-radius: 4px;
    background-color: var(--bal-color-black);
  }

  .consent {
    //aspect-ratio: 16/9; fix BARE-1967
    background: var(--bal-color-grey-2);
    border: 1px solid var(--bal-color-grey-5);
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    contain: content;
    position: relative;
    width: 100%;

    bal-button {
      padding: 0 0 0 4px;
      min-height: auto !important;
    }
  }

  bal-card {
    margin: 20px 16px;
    max-width: 600px;
    @include tablet() {
      margin: 40px;
    }
  }

  bal-card,
  bal-card-content {
    height: auto !important;
  }

  bal-card-content {
    overflow-y: hidden;

    bal-text {
      overflow-y: auto;
    }
  }
}
